import React from 'react';
import { EntriModule, ModalsModule } from './extensions/ModalsExtensions';
export const ModalsProvider = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(EntriModule.Provider, null, /*#__PURE__*/React.createElement(ModalsModule.SDK.DomainsActionsModals, null), /*#__PURE__*/React.createElement(ModalsModule.SDK.DomainsSharedModals, null), /*#__PURE__*/React.createElement(EntriModule.SDK.DomainsEntriModals, null), children);
};
//# sourceMappingURL=ModalsProvider.js.map